import React from "react";
import PropTypes from "prop-types";

import styles from "./styles.css";
import Modal from "../../shared/modal";
import Button from "../../shared/button";
import CloseButton from "../../shared/icon-cross";

const HowToBookTestModal = ({onClose, handleFaqModal, onClickTestDrive}) => {
    return (
        <Modal isOpen={true}>
            <div styleName={"styles.outer"}>
                <div styleName={"styles.headerWrap"}>
                    <p styleName={"styles.nextStep"}>How to book your test drive</p>
                    <CloseButton type="grey" onClickHandler={onClose}/>
                </div>
                <div styleName={"styles.nextStepWrap"}>
                    <div className="media" styleName={"styles.stepWrapper"}>
                        <p styleName={"styles.stepCount"}>1</p>
                        <div className="media-body">
                            <p styleName={"styles.stepHead"}>Secure your slot </p>
                            <p styleName={"styles.stepDetail"}>Pay a refundable $500 deposit to reserve the car for 3 days</p>
                        </div>
                    </div>
                    <div className="media" styleName={"styles.stepWrapper"}>
                        <p styleName={"styles.stepCount"}>2</p>
                        <div className="media-body">
                            <p styleName={"styles.stepHead"}>Test drive the car</p>
                            <p styleName={"styles.stepDetail"}>Our team will be in touch to finalise your test-drive time and date</p>
                        </div>
                    </div>
                    <div className="media" styleName={"styles.stepWrapper"}>
                        <p styleName={"styles.stepCount"}>3</p>
                        <div className="media-body">
                            <p styleName={"styles.stepHead"}> Purchase the car </p>
                            <p styleName={"styles.stepDetail"}>If you’re happy with the car, pay using cash or financing and arrange delivery</p>
                        </div>
                    </div>
                    <div className="media" styleName={"styles.stepWrapper"}>
                        <p styleName={"styles.stepCount"}>4</p>
                        <div className="media-body">
                            <p styleName={"styles.stepHead"}>Test own for 7 days</p>
                            <p styleName={"styles.stepDetail"}>If you don’t like the car in 7 days, return it and we’ll give you a 100% refund </p>
                        </div>
                    </div>
                </div>
                <div styleName={"styles.quetions"}>
                    <h4 styleName={"styles.text"}>Have any questions? <span onClick={handleFaqModal}>Read our test-drive FAQs</span></h4>
                </div>
                <div styleName={"styles.buttonWrap"}>
                    <Button text="Book a test drive" onClick={onClickTestDrive} />
                </div>
            </div>
        </Modal>

    );
};

HowToBookTestModal.propTypes = {
    onClose: PropTypes.func,
    handleFaqModal: PropTypes.func,
    onClickTestDrive: PropTypes.func
};

export default HowToBookTestModal;
